import { ComponentProps } from "react";
import { useNavigate, useParams } from "react-router";
import { useClaService } from "../../../adapters/cla/state/hooks/useClaService.ts";
import { ResearchId } from "../../../adapters/insights-agent/state/AppState.ts";
import { HistorySidebar as HistorySidebarLegacy } from "../../../feature-components/HistorySidebar/HistorySidebar.tsx";
import { FloatingMenu } from "../../../ui-library/FloatingMenu/FloatingMenu.tsx";
import { FloatingMenuItem } from "../../../ui-library/FloatingMenu/FloatingMenuItem.tsx";

type ContextMenuComponentType = ComponentProps<
  typeof HistorySidebarLegacy
>["ContextMenuComponent"];
export const CustomContextMenu: ContextMenuComponentType = (props: {
  id: string;
}) => {
  const navigate = useNavigate();
  const { id: currentId } = useParams();
  const claService = useClaService();
  return (
    <FloatingMenu>
      <FloatingMenuItem
        onClick={() => {
          const newName = window.prompt("Enter new name for this chat", "");
          if (!newName) return;
          claService
            .renameChat({ chatId: props.id as ResearchId, name: newName })
            .then(() => {});
        }}
      >
        Rename chat
      </FloatingMenuItem>
      <FloatingMenuItem
        onClick={() => {
          if (props.id === currentId) navigate("/chats/new");
          const confirmed = window.confirm(
            "Are you sure you want to delete this chat?",
          );
          if (!confirmed) return;
          claService
            .deleteChat({ chatId: props.id as ResearchId })
            .then(() => {});
        }}
      >
        Delete chat
      </FloatingMenuItem>
    </FloatingMenu>
  );
};
